import React from "react";
import { passwordValidation } from "../../functions/validations";

// Match the existing signup validator, including its 16-character maximum
// and restricted symbol set. This component does not change acceptance rules.
export default function PasswordRequirements({ id, password = "" }) {
  const requirements = [
    { label: "8–16 characters", met: password.length >= 8 && password.length <= 16 },
    { label: "An uppercase letter", met: /[A-Z]/.test(password) },
    { label: "A lowercase letter", met: /[a-z]/.test(password) },
    { label: "A number", met: /[0-9]/.test(password) },
    { label: "A special character: !@#$%^&*", met: /[!@#$%^&*]/.test(password) },
  ];
  const hasUnsupportedCharacters = /[^a-zA-Z0-9!@#$%^&*]/.test(password);
  const metCount = requirements.filter(({ met }) => met).length;
  const valid = passwordValidation(password);
  const status = hasUnsupportedCharacters
    ? "Remove unsupported characters."
    : valid
      ? "Password requirements met"
      : `${metCount} of ${requirements.length} requirements met`;

  return (
    <section
      id={id}
      aria-label="Password requirements"
      style={{
        background: "#f5f7fa",
        borderRadius: "8px",
        padding: "10px 12px",
        color: "#505b6b",
        fontSize: "13px",
        lineHeight: 1.5,
      }}>
      <p style={{ margin: "0 0 6px", fontWeight: 600, lineHeight: "inherit" }}>Your password needs:</p>
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {requirements.map(({ label, met }) => (
          <li
            key={label}
            style={{ display: "flex", gap: "6px", marginBottom: "2px", color: met ? "#186a3b" : "#505b6b" }}>
            <span aria-hidden="true" style={{ width: "18px", flexShrink: 0, textAlign: "center" }}>
              {met ? "✓" : "○"}
            </span>
            <span>
              <span className="visually-hidden">{met ? "Met: " : "Still needed: "}</span>
              {label}
            </span>
          </li>
        ))}
      </ul>
      <p style={{ margin: "6px 0 0", lineHeight: "inherit" }}>
        Use only A–Z, a–z, 0–9 and !@#$%^&*. Spaces are not allowed.
      </p>
      <p
        role="status"
        aria-live="polite"
        aria-atomic="true"
        style={{ margin: "6px 0 0", lineHeight: "inherit", color: valid ? "#186a3b" : "#505b6b", fontWeight: valid ? 600 : 400 }}>
        {status}
      </p>
    </section>
  );
}

